import { withLazyFallback } from 'lib/hoc/withLazyFallback';

const AchOnFile = withLazyFallback(
  () => import('components/practice/charts/Account/tabs/AchOnFile/AchOnFile')
);
const NotFound = withLazyFallback(() => import('components/NotFound'));
const PatientAccount = withLazyFallback(() => import('components/practice/charts/Account/Account'));
const CConFile = withLazyFallback(
  () => import('components/practice/charts/Account/tabs/CConFile/CConFileTable')
);
const PurchasedPackages = withLazyFallback(
  () => import('components/practice/charts/Account/tabs/PurchasedPackages/PurchasedPackages')
);
const Quotes = withLazyFallback(
  () => import('components/practice/charts/Account/tabs/Quotes/Quotes')
);
const PracticePatientSettings = withLazyFallback(
  () => import('components/practice/charts/PracticePatientSettings')
);

const PRACTICE_CHARTS_ACCOUNT = [
  {
    path: 'account',
    element: <PatientAccount />,
    children: [
      { path: '', element: <PurchasedPackages /> },
      { path: 'purchased-packages', element: <PurchasedPackages /> },
      { path: 'quotes', element: <Quotes /> },
      { path: 'settings', element: <PracticePatientSettings /> },
      { path: 'cards', element: <CConFile /> },
      { path: 'ach', element: <AchOnFile /> },
      { path: '*', element: <NotFound /> }
    ]
  }
];

export default PRACTICE_CHARTS_ACCOUNT;
